/** Shown when the active switcher option is an Emmy facility the user can access via `cognito:groups` but for which
 *  no hlas-emmy practice has been configured yet (PRD-010 Stage 2 §Phase 2.2 — per-facility "not set up" page).
 *
 *  Rendered inside the normal DoctorApp chrome so the combobox stays available — the user can switch to another
 *  (configured) practice without signing out.
 */
export const FacilityNotSetUpPage = ({ facilityId }: { facilityId: string }) => {
  return (
    <main className="mx-auto max-w-2xl p-8">
      <div className="rounded-2xl border border-gray-200 bg-white p-8 shadow-sm">
        <h1 className="mb-3 text-2xl tracking-tight text-[#1a2b6b]">
          hlas emmy zatím není nastaven pro tuto ordinaci
        </h1>
        <p className="mb-3 text-base text-gray-700">
          Pro tuto ordinaci ještě není služba <span className="italic">hlas emmy</span> aktivní. Pokud máte přístup
          k více ordinacím, můžete přepnout v pravém horním rohu.
        </p>
        <p className="mb-6 text-base text-gray-700">
          Chcete-li službu nastavit i pro tuto ordinaci, napište nám na{" "}
          <a href="mailto:podpora@sestraemmy.cz" className="text-[#1a2b6b] underline hover:opacity-80">
            podpora@sestraemmy.cz
          </a>{" "}
          a rádi vám ji aktivujeme.
        </p>
        <div className="rounded-md border border-gray-200 bg-gray-50 p-3 text-xs text-gray-600">
          <span className="font-semibold">ID zařízení (facility) pro podporu:</span>{" "}
          <code className="break-all">{facilityId}</code>
        </div>
        <a
          href={`mailto:podpora@sestraemmy.cz?subject=${encodeURIComponent(
            "hlas emmy — žádost o aktivaci ordinace",
          )}&body=${encodeURIComponent(`Dobrý den,\n\nrád bych aktivoval službu hlas emmy pro ordinaci s facility ID: ${facilityId}.\n\nDěkuji.`)}`}
          className="mt-6 inline-block rounded-md bg-[#1a2b6b] px-4 py-2 text-sm text-white hover:opacity-80"
        >
          Kontaktovat podporu
        </a>
      </div>
    </main>
  );
};
